<template>
  <div class="mainMenuModal">
		<div class="mainMenuBlock" v-if="this.preferences != null">
			<div class="categoryBlock">
				<p class='categoryHeadText'>Секс</p>
				<ol>
					<a v-for='cat in preferences.SEX' v-bind:key='cat' :href="user ? '/girls/' + cat._id + '/1' : '#'" @click="openAuth"><li >{{cat.name}}</li></a>
				</ol>
			</div>
			<div class="categoryBlock">
				<p class='categoryHeadText'>Массаж</p>
				<ol>
					<a v-for='cat in preferences.MASSAGE' v-bind:key='cat' :href="user ? '/girls/' + cat._id + '/1' : '#'" @click="openAuth"><li >{{cat.name}}</li></a>
				</ol>
				<div class="categoryBlock">
					<p class='categoryHeadText'>
						Экстрим 
						<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M11.6355 2.348C10.6486 -0.782667 6.35143 -0.782667 5.36452 2.348C5.07435 3.26846 4.24215 3.89165 3.30316 3.89165C0.109434 3.89165 -1.21845 8.10394 1.36533 10.0388C2.12499 10.6077 2.44286 11.616 2.1527 12.5365C1.16578 15.6671 4.64223 18.2705 7.22601 16.3356C7.98567 15.7667 9.01433 15.7668 9.77399 16.3356C12.3578 18.2705 15.8342 15.6671 14.8473 12.5365C14.5571 11.616 14.875 10.6077 15.6347 10.0388C18.2185 8.10394 16.8906 3.89165 13.6968 3.89165C12.7578 3.89165 11.9256 3.26846 11.6355 2.348Z" fill="#FF8989"/>
						</svg>
					</p>
	
					<ol>
						<a v-for='cat in preferences.EXTREME' v-bind:key='cat' :href="user ? '/girls/' + cat._id + '/1' : '#'" @click="openAuth"><li >{{cat.name}}</li></a>
					</ol>
				</div>
			</div>
			<div class="categoryBlock">
				<p class='categoryHeadText'>Садо-мазо</p>
				<ol>
					<a v-for='cat in preferences.BDSM' v-bind:key='cat' :href="user ? '/girls/' + cat._id + '/1' : '#'" @click="openAuth"><li >{{cat.name}}</li></a>
				</ol>
				<div class="categoryBlock">
					<p class='categoryHeadText'>Стриптиз</p>
					<ol>
						<a v-for='cat in preferences.STRIPTEASE' v-bind:key='cat' :href="user ? '/girls/' + cat._id + '/1' : '#'" @click="openAuth"><li >{{cat.name}}</li></a>
					</ol>
				</div>
			</div>
			<div class="categoryBlock">
				<p class='categoryHeadText'>Разное</p>
				<ol>
					<a v-for='cat in preferences.ETC' v-bind:key='cat' :href="user ? '/girls/' + cat._id + '/1' : '#'" @click="openAuth"><li >{{cat.name}}</li></a>
				</ol>
			</div>
		</div>
  </div>
</template>

<script>
import categories from '@/data/categories'
import axios from 'axios'
import { useToast } from 'vue-toastification';
export default {
  name: 'MainMenu',
	data() {
		return {
			categories,
			preferences: null,
			user: this.$store.getters.getUserData,
			isMobile: false,
		}
	},
	methods: {
		searchCategory() {
			axios.get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/preferences`)
			.then(res => {
				console.log(res)
				this.preferences = res.data.result.reduce((result, item) => {
					const category = item.category;
					if (!result[category]) {
						result[category] = [];
					}
					result[category].push(item);
					return result;
				}, {});
				console.log(this.preferences)
			})
			.catch(err => {
				console.log(err)
			})
		},
		openAuth() {
			if (!this.user) {
				this.toast.error("Необходимо войти или пройти регистрацию")
			}
		}
	},
	mounted() {
		this.searchCategory()
		this.isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
	},
	setup() {
		const toast = useToast()
		return {toast}
	},
  components: {
    
  }
}
</script>
<style>
.mainMenuModal {
	background-color: #232323E5;
	backdrop-filter: blur(8px);
	color: white;
	position: fixed;
	left:0;
	top:0;
	width: 100vw;
	height: 100vh;
	z-index: 5000;
	padding: 10%;
	padding-top: 5%;
}
.mainMenuBlock {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
}
.categoryBlock ol {
	list-style-type: none;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap:5px;
}
.categoryBlock ol li {
	font-weight: 600;
	cursor: pointer;
	user-select: none;
}
.categoryBlock {
	display: flex;
	flex-direction: column;
	gap:20px;
	justify-self: left;
}
.categoryHeadText {
	font-weight: 600;
	font-size: 24px;
}
a {
	color: inherit;
	outline: none;
	text-decoration: none;
}
@media (max-width:968px) {
	.mainMenuModal {
		overflow-y: scroll;
		padding-bottom: 20%;
		box-sizing: content-box;
	}
	.mainMenuBlock {
		overflow-y: scroll;
		height: 80vh;
		margin-top: 20%;
		display: flex;
		flex-direction: column;
		/* grid-template-columns: 1fr; */
		gap:20px;
		top:250px;
	}
	.categoryBlock {
		top:250px;
	}
}
</style>
